// Content for the Podcasts page: podcast cases (episodes), shorts cut from those
// cases, and the premium-content column. Episodes are listed newest first.
//
// To publish a new episode:
//   1. Upload the video to s3://tni-video-uploads/<ID>.mp4 — this triggers HLS
//      conversion automatically; the stream appears at
//      https://cdn.mskexperts.com/<ID>/<ID>.m3u8 after ~10 minutes
//   2. Upload a thumbnail PNG to s3://tni-assets/assets/images/video-thumbs/<ID>.png
//   3. Add an entry at the top of PODCAST_EPISODES (or PODCAST_SHORTS, with the
//      caseId of the episode it was cut from) and deploy.
export type PodcastEpisode = {
  id: string
  title: string
  description: string
  publishedAt: string // ISO date, e.g. 2026-09-24
  durationMinutes: number
  videoUrl: string
  thumbnailUrl: string
}

export type PodcastShort = PodcastEpisode & {
  caseId: string // id of the PodcastEpisode this short was cut from
}

export type PremiumItem = {
  title: string
  description: string
  route?: string // internal app route
  externalUrl?: string // external link
}

const CDN = 'https://cdn.mskexperts.com'

export const SIGNUP_URL = 'https://therapeuticneedling.com/shop'

export const PODCAST_EPISODES: PodcastEpisode[] = [
  {
    id: 'PODCAST0001',
    title: 'Chronic Pain in the Calf, Part 1',
    description:
      'Persistent unilateral calf pain for six years in a physically active healthcare worker. Part 1 of a case discussion.',
    publishedAt: '2026-09-24',
    durationMinutes: 17,
    videoUrl: `${CDN}/PODCAST0001/PODCAST0001.m3u8`,
    thumbnailUrl: `${CDN}/assets/images/video-thumbs/PODCAST0001.png`,
  },
]

export const PODCAST_SHORTS: PodcastShort[] = []

export const PREMIUM_CONTENT: PremiumItem[] = [
  {
    title: 'Therapeutic Needling Video Library',
    description:
      'Real patient cases from assessment through needling procedure and follow-up, filterable by site of pain, onset, symptoms and more.',
    route: '/patient-videos',
  },
  {
    title: 'Community Forum',
    description:
      'Post your own cases, ask questions and discuss the podcast cases with colleagues who practice therapeutic needling.',
    route: '/community',
  },
]

export const findEpisode = (id?: string) =>
  PODCAST_EPISODES.find((e) => e.id === id)

export const shortsForCase = (caseId: string) =>
  PODCAST_SHORTS.filter((s) => s.caseId === caseId)
